import { useEffect, useRef } from "react";

// Adds .in-view to elements with .reveal class once they enter the viewport.
export default function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const targets = root.querySelectorAll(".reveal");
    if (!targets.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.12 }
    );

    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, []);

  return ref;
}
